<!---event card horizontal-->
<ng-container *ngIf="type === 'horizontal'">
	<div class="event-card fx-column fx-start-stretch">
		<ng-container *ngIf="cardData?.forwarderName || ![null, undefined, ''].includes(cardData?.forwarderThumbnail)">
			<div class="forward-user-block fx-row fx-start-center">
				<mat-icon class="forward-icon" svgIcon="forward_content"></mat-icon>
				<ng-container *ngIf="![null, undefined, ''].includes(cardData?.forwarderThumbnail)">
					<img class="img" (click)="forwarderUserInfo(cardData)" [src]="cardData?.forwarderThumbnail"
						(error)="gfService.setErrorImage($event, 'man')">
				</ng-container>
				<ng-container *ngIf="cardData?.forwarderName">
					<span class="sub-caption-1">{{cardData?.forwarderName}}</span>
				</ng-container>
			</div>
		</ng-container>
		<div class="fx-row fx-space-between-stretch">
			<div class="fx-row fx-start-stretch fx-grow fx-shrink">
				<ng-container *ngIf="cardData?.thumbnail">
					<div class="fx-row fx-start-start fx-no-grow fx-no-shrink">
						<div class="thumbnail-block fx-row">
							<div class="thumbnail fx-row fx-center-center" (click)="info(cardData)">
								<ng-container *ngIf="cardData?.thumbnail">
									<img [src]="cardData?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')" alt="">
								</ng-container>
							</div>
						</div>
					</div>
				</ng-container>
				<ng-container
					*ngIf="cardData?.type || cardData?.title || cardData?.description || cardData?.date || cardData?.time || cardData?.actions?.length || ![null, undefined].includes(cardData?.commentsCount)">
					<div class="content-block fx-column fx-start-stretch fx-grow fx-shrink">
						<ng-container *ngIf="cardData?.type">
							<div class="patch-block fx-row fx-space-between-center">
								<ng-container [ngTemplateOutlet]="typePatch" [ngTemplateOutletContext]="{data: cardData}">
								</ng-container>
								<!-- <ng-container *ngIf="data?.type" [ngTemplateOutlet]="statusPatch"
								[ngTemplateOutletContext]="{data: data}">
							</ng-container> -->
							</div>
						</ng-container>
						<ng-container
							*ngIf="cardData?.title || cardData?.description || cardData?.date || cardData?.time || cardData?.actions?.length || ![null, undefined].includes(cardData?.commentsCount)">
							<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
								<ng-container *ngIf="cardData?.title || cardData?.description">
									<div class="event-dtls fx-column fx-start-stretch fx-grow fx-shrink">
										<div class="fx-column fx-start-start fx-grow fx-shrink">
											<ng-container *ngIf="cardData?.title">
												<p class="card-title linkable" (click)="info(cardData)">{{cardData?.title}}</p>
											</ng-container>
											<ng-container *ngIf="cardData?.description">
												<p class="card-description">{{cardData?.description}}</p>
											</ng-container>
										</div>
									</div>
								</ng-container>
								<ng-container
									*ngIf="cardData?.date || cardData?.time || cardData?.actions?.length || ![null, undefined].includes(cardData?.commentsCount)">
									<div class="fx-row-wrap fx-space-between-center">
										<ng-container *ngIf="cardData?.date || cardData?.time || cardData?.actions?.length">
											<div class="fx-row fx-start-center">
												<ng-container *ngIf="cardData?.date || cardData?.time">
													<ng-container *ngIf="cardData?.eventType === 'internalEvent'">
														<div fxFlex="0 0 auto" class="patch-small date" [ngClass]="cardData?.dateClasses"
															fxLayoutAlign="center center" fxLayout="row">
															<ng-container *ngIf="cardData?.time">
																<span>{{cardData?.time}}</span>
															</ng-container>
															<ng-container *ngIf="cardData?.time && cardData?.date">
																<span>|</span>
															</ng-container>
															<ng-container *ngIf="cardData?.date">
																<span>{{cardData?.date}}</span>
															</ng-container>
														</div>
													</ng-container>
													<ng-container *ngIf="cardData?.eventType === 'externalEvent'">
														<ng-container *ngIf="cardData?.date">
															<div class="patch-small date" fxFlex="0 0 auto" fxLayoutAlign="center center"
																[ngClass]="cardData?.dateClasses" fxLayout="row">
																<span>{{cardData?.date}}</span>
															</div>
														</ng-container>
													</ng-container>
												</ng-container>
												<ng-container *ngIf="cardData?.actions?.length" [ngTemplateOutlet]="actions"
													[ngTemplateOutletContext]="{data: cardData}">
												</ng-container>
											</div>
										</ng-container>
										<!-- <ng-container *ngIf="![null, undefined].includes(data?.commentsCount)">
										<app-badge [count]="data?.commentsCount | abbreviateNumber" svgIcon="comments" size="16px"
											class="event-comment-count"></app-badge>
									</ng-container> -->
										<ng-container
											*ngIf="![null, undefined].includes(cardData?.rating) || ![null, undefined].includes(cardData?.commentsCount)">
											<div class="fx-row fx-start-center">
												<ng-container *ngIf="![null, undefined].includes(cardData?.rating)">
													<div class="rating">
														<ng-container *ngFor="let rate of cardData?.ratingData">
															<ng-container *ngIf="rate?.isInt && rate?.value !== 0">
																<mat-icon>star</mat-icon>
															</ng-container>
															<ng-container *ngIf="rate?.isFloat && rate?.value !== 0">
																<mat-icon>star_half</mat-icon>
															</ng-container>
															<ng-container *ngIf="rate?.value === 0">
																<mat-icon>star_border</mat-icon>
															</ng-container>
														</ng-container>
													</div>
												</ng-container>
												<ng-container *ngIf="![null, undefined].includes(cardData?.commentsCount)">
													<app-badge [count]="cardData?.commentsCount | abbreviateNumber" svgIcon="comments" size="16px"
														class="event-comment-count"></app-badge>
												</ng-container>
											</div>
										</ng-container>
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</ng-container>
			</div>
			<ng-container *ngIf="cardData?.removable">
				<div class="cancel fx-start-start">
					<button class="cancel-btn" mat-icon-button #actionBtn
						(click)="close({'actionElement': actionBtn, 'data': cardData})">
						<mat-icon svgIcon="delete"></mat-icon>
					</button>
				</div>
			</ng-container>
		</div>
	</div>
</ng-container>
<!---end-->

<!---event card vertical-->
<ng-container *ngIf="type === 'vertical'">
	<div class="event-card  vertical fx-column fx-start-stretch">
		<ng-container *ngIf="cardData?.forwarderName || ![null, undefined, ''].includes(cardData?.forwarderThumbnail)">
			<div class="forward-user-block fx-row fx-start-center">
				<mat-icon class="forward-icon" svgIcon="forward_content"></mat-icon>
				<ng-container *ngIf="![null, undefined, ''].includes(cardData?.forwarderThumbnail)">
					<img class="img" (click)="forwarderUserInfo(cardData)" [src]="cardData?.forwarderThumbnail"
						(error)="gfService.setErrorImage($event, 'man')">
				</ng-container>
				<ng-container *ngIf="cardData?.forwarderName">
					<span class="sub-caption-1">{{cardData?.forwarderName}}</span>
				</ng-container>
			</div>
		</ng-container>
		<div class="fx-column fx-start-stretch fx-grow fx-shrink">
			<ng-container *ngIf="cardData?.thumbnail">
				<div class="thumbnail-block" (click)="info(cardData)">
					<div class="thumbnail  fx-row fx-center-center">
						<img [src]="cardData?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')" alt="">
					</div>
				</div>
			</ng-container>
			<ng-container
				*ngIf="cardData?.type && cardData?.title || cardData?.description || cardData?.date || cardData?.time || cardData?.actions?.length || ![null, undefined].includes(cardData?.commentsCount)">
				<div class="content-block  fx-column fx-start-stretch fx-grow fx-shrink">
					<ng-container *ngIf="cardData?.type">
						<div class="patch-block fx-row fx-space-between-center">
							<ng-container *ngIf="cardData?.type" [ngTemplateOutlet]="typePatch"
								[ngTemplateOutletContext]="{data: cardData}">
							</ng-container>
							<!-- <ng-container *ngIf="data?.type" [ngTemplateOutlet]="statusPatch"
								[ngTemplateOutletContext]="{data: data}">
							</ng-container> -->
						</div>
					</ng-container>
					<ng-container
						*ngIf="cardData?.title || cardData?.description || cardData?.date || cardData?.time || cardData?.actions?.length || ![null, undefined].includes(cardData?.commentsCount)">
						<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
							<!--title and desc-->
							<ng-container *ngIf="cardData?.title || cardData?.description">
								<div class="fx-column fx-start-stretch fx-grow fx-shrink">
									<div class="fx-column fx-start-stretch fx-grow fx-shrink">
										<ng-container *ngIf="cardData?.title">
											<p class="card-title linkable" (click)="info(cardData)">{{cardData?.title}}</p>
										</ng-container>
										<ng-container *ngIf="cardData?.description">
											<p class="card-description">{{cardData?.description}}</p>
										</ng-container>
									</div>
								</div>
							</ng-container>
							<ng-container
								*ngIf="cardData?.date || cardData?.time || cardData?.actions?.length || ![null, undefined].includes(cardData?.commentsCount)">
								<div class="fx-column fx-center-center">
									<ng-container *ngIf="cardData?.date || cardData?.time">
										<ng-container *ngIf="cardData?.eventType === 'internalEvent'">
											<div fxFlex="0 0 auto" class="patch-small date fx-row fx-center-center"
												[ngClass]="cardData?.dateClasses">
												<ng-container *ngIf="cardData?.time">
													<span>{{cardData?.time}}</span>
												</ng-container>
												<ng-container *ngIf="cardData?.time && cardData?.date">
													<span>|</span>
												</ng-container>
												<ng-container *ngIf="cardData?.date">
													<span>{{cardData?.date}}</span>
												</ng-container>
											</div>
										</ng-container>
										<ng-container *ngIf="cardData?.eventType === 'externalEvent'">
											<ng-container *ngIf="cardData?.date">
												<div class="patch-small date" fxFlex="0 0 auto" fxLayoutAlign="center center" fxLayout="row"
													[ngClass]="cardData?.dateClasses">
													<span>{{cardData?.date}}</span>
												</div>
											</ng-container>
										</ng-container>
									</ng-container>
									<ng-container *ngIf="cardData?.actions?.length">
										<div class="fx-row-wrap fx-center-center">
											<ng-container *ngIf="cardData?.actions?.length">
												<div class="fx-row fx-center-center">
													<ng-container [ngTemplateOutlet]="actions" [ngTemplateOutletContext]="{data: cardData}">
													</ng-container>
												</div>
											</ng-container>
											<!-- <ng-container *ngIf="data?.type" [ngTemplateOutlet]="statusPatch"
												[ngTemplateOutletContext]="{data: data}">
											</ng-container> -->
										</div>
									</ng-container>
								</div>
								<!-- <ng-container *ngIf="![null, undefined].includes(data?.commentsCount)">
									<div class="fx-row fx-end-center">
										<app-badge [count]="data?.commentsCount | abbreviateNumber" svgIcon="comments" size="16px"
											class="event-comment-count"></app-badge>
									</div>
								</ng-container> -->
								<ng-container
									*ngIf="![null, undefined].includes(cardData?.rating) || ![null, undefined].includes(cardData?.commentsCount)">
									<div class="fx-row-wrap"
										[ngClass]="((![null, undefined].includes(cardData?.rating) && ![null, undefined].includes(cardData?.commentsCount))) ? 'fx-space-between-center' : 'fx-end-center'">
										<ng-container *ngIf="![null, undefined].includes(cardData?.rating)">
											<div class="rating fx-row fx-start-center">
												<ng-container *ngFor="let rate of cardData?.ratingData">
													<ng-container *ngIf="rate?.isInt && rate?.value !== 0">
														<mat-icon>star</mat-icon>
													</ng-container>
													<ng-container *ngIf="rate?.isFloat && rate?.value !== 0">
														<mat-icon>star_half</mat-icon>
													</ng-container>
													<ng-container *ngIf="rate?.value === 0">
														<mat-icon>star_border</mat-icon>
													</ng-container>
												</ng-container>
											</div>
										</ng-container>
										<ng-container *ngIf="![null, undefined].includes(cardData?.commentsCount)">
											<app-badge [count]="cardData?.commentsCount | abbreviateNumber" svgIcon="comments" size="16px"
												class="event-comment-count"></app-badge>
										</ng-container>
									</div>
								</ng-container>
							</ng-container>
						</div>
					</ng-container>
				</div>
			</ng-container>
		</div>
	</div>
</ng-container>
<!--end-->

<!---event card minimal-->
<ng-container *ngIf="type === 'minimal'">
	<div class="event-card minimal fx-column fx-start-stretch">
		<div class="fx-row fx-start-stretch fx-grow fx-shrink">
			<div class="fx-row fx-start-stretch fx-grow fx-shrink">
				<ng-container *ngIf="cardData?.thumbnail">
					<div class="fx-row fx-start-start fx-no-grow fx-no-shrink">
						<div class="minimal-thumbnail-block fx-row">
							<div class="minimal-thumbnail fx-row fx-center-center" (click)="info(cardData)">
								<ng-container *ngIf="cardData?.thumbnail">
									<img [src]="cardData?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')" alt="">
								</ng-container>
							</div>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="cardData?.type || cardData?.title">
					<div class="content-block fx-column fx-start-stretch fx-grow fx-shrink">
						<ng-container *ngIf="cardData?.type">
							<div class="patch-block fx-row fx-space-between-center">
								<ng-container [ngTemplateOutlet]="typePatch" [ngTemplateOutletContext]="{data: cardData}">
								</ng-container>
							</div>
						</ng-container>
						<ng-container *ngIf="cardData?.title">
							<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
								<ng-container *ngIf="cardData?.title">
									<div class="event-dtls fx-column fx-start-stretch fx-grow fx-shrink">
										<ng-container *ngIf="cardData?.title">
											<p class="card-title linkable" (click)="info(cardData)">{{cardData?.title}}</p>
										</ng-container>
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</ng-container>
			</div>
			<ng-container *ngIf="cardData?.removable">
				<div class="cancel fx-center-center">
					<button class="cancel-btn" mat-icon-button #actionBtn
						(click)="close({'actionElement': actionBtn, 'data': cardData})">
						<mat-icon svgIcon="delete"></mat-icon>
					</button>
				</div>
			</ng-container>
		</div>
	</div>
</ng-container>
<!---end-->


<ng-template #typePatch let-data="data">
	<div class="content-type" fxLayoutAlign="start start">
		<div class="patch sub-txt-patch">{{data?.type}}</div>
	</div>
</ng-template>

<ng-template #statusPatch let-data="data">
	<p class="sub-txt-patch success">{{data?.status}}</p>
</ng-template>

<ng-template #actions let-data="data">
	<div class="button-block fx-row" [ngClass]="type === 'horizontal' ? 'fx-start-center' : 'fx-center-center'">
		<ng-container *ngFor="let action of data?.actions">
			<button mat-stroked-button class="sub-action-prime-btn" type="button" #actionEl [ngClass]="action?.classes"
				(click)="actionInfo({actionEl: actionEl, action: action})">
				{{action?.caption}}
			</button>
		</ng-container>
	</div>
</ng-template>
